import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function F() {
    const { useLang } = useGlobal();
    const { t } = useLang('solar60w');
    return (
        <div className={`solar-60w-F ${css['solar-60w-F']}`}>
            <div className="text-box">
                <p className="title">{t('sec6_title')}</p>
                <p className="desc">
                    {t.rich('sec6_desc', {
                        black: (text: string) => <span className="black">{text}</span>,
                    })}
                </p>
            </div>
            <div className="img-box">
                <div className="img-left">
                    <NextImage src={require('@publicLocal/solar-60w/pc/6_1.jpg')} alt={t('sec6_title')} aria-label={t('sec6_title')} />
                    <div className="text-box box1">
                        <span className="text">{t('sec6_img1_text1')}</span>
                        <span className="line"></span>
                        <span className="circle"></span>
                    </div>
                    <div className="text-box box2">
                        <span className="text">{t('sec6_img1_text2')}</span>
                        <span className="line"></span>
                        <span className="circle"></span>
                    </div>
                    <div className="text-box box3">
                        <span className="text">{t('sec6_img1_text3')}</span>
                        <span className="line"></span>
                        <span className="circle"></span>
                    </div>
                    <div className="text-box box4">
                        <span className="text">{t('sec6_img1_text4')}</span>
                        <span className="line"></span>
                        <span className="circle"></span>
                    </div>
                    <div className="text-box box5">
                        <span className="text">{t('sec6_img1_text5')}</span>
                        <span className="line"></span>
                        <span className="circle"></span>
                    </div>
                    <div className="text-box box6">
                        <span className="text">{t('sec6_img1_text6')}</span>
                        <span className="line"></span>
                        <span className="circle"></span>
                    </div>
                    <div className="text-box box7">
                        <span className="text">{t('sec6_img1_text7')}</span>
                        <span className="line"></span>
                        <span className="circle"></span>
                    </div>
                </div>
                <div className="img-right">
                    <NextImage src={require('@publicLocal/solar-60w/pc/6_2.jpg')} alt={t('sec6_title')} aria-label={t('sec6_title')} />
                    <div className="text">
                        {t.rich('sec6_img2_text', {
                            big: (text: string) => <span className="big">{text}</span>,
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}
